import { colors } from "const/colors";
import { Article, Section, SectionSmall, Text } from "styles";

import StoreBadges from "../StoreBadges/StoreBadges";

export default function ClosingCta() {
	return (
		<Section>
			<SectionSmall style={{ flexDirection: "column", width: "100%", textAlign: "center" }}>
				<Article>
					<Text midExtreme>
						Start saving <Text color={colors.magenta}>today</Text>. For{" "}
						<Text color={colors.green}>tomorrow</Text>.
					</Text>
					<Text lede style={{ display: "block", marginTop: 18 }}>
						Use Wishbox to track your spending, save for your goals, collaborate, and work with AI
						easily.
					</Text>
					<div style={{ display: "flex", justifyContent: "center", marginTop: 28 }}>
						<StoreBadges align="center" />
					</div>
				</Article>
			</SectionSmall>
		</Section>
	);
}
